
// frontend/src/tour/steps/territories.steps.js
import { resolveTourSteps } from "../resolveTourSteps";
export const TERRITORIES_TOUR_STEPS = (role) => {
  // Normalize role name
  const normalizedRole = normalizeRole(role);
  
  const steps = [
    {
      id: "add-territory-button",
      selector: '[data-tour="add-territory-button"]',
      placement: "bottom",
      copy: {
        Admin: {
          title: "Add New Territory",
          content:
            "Click this button to create a new territory. You can quickly set up a territory name, assign a manager, and add reps.",
        },
        Manager: {
          title: "Add New Territory",
          content:
            "Use this button to create new territories for your team. Assign managers and reps to ensure proper coverage.",
        },
        "Sales Rep": {
          title: "Territories",
          content:
            "This page shows all territories. Contact your manager if you need access to additional territories.",
        },
      },
    },
    {
      id: "upload-leads-chip",
      selector: '[data-tour="upload-leads-chip"]',
      placement: "left",
      copy: {
        Admin: {
          title: "Upload Leads",
          content:
            "Click this to upload leads for this territory. It opens the upload page where you can add leads from a CSV or Excel file.",
        },
        Manager: {
          title: "Upload Leads",
          content:
            "Use this to open the upload page for this territory. You can bulk upload leads from a file or add leads there.",
        },
        "Sales Rep": {
          title: "Upload Leads",
          content:
            "Tap here to open the upload page for this territory and add or upload leads.",
        },
      },
    },
  ];

  // Resolve steps based on role
  return steps.map((step) => {
    const roleCopy = step.copy[normalizedRole] || step.copy["Sales Rep"];
    
    return {
      selector: step.selector,
      placement: step.placement,
      title: roleCopy.title,
      content: roleCopy.content,
    };
  });
};

// Helper function to normalize role names
function normalizeRole(role) {
  if (!role) return "Sales Rep";
  const roleLower = role.toLowerCase();
  if (roleLower.includes("admin")) return "Admin";
  if (roleLower.includes("director")) return "Admin"; // Sales Director uses Admin copy
  if (roleLower.includes("manager")) return "Manager";
  return "Sales Rep";
}

/**
 * Versioned "new only" tour for Territories.
 * Shown to users who already completed the full tour (v1_5) but haven't seen this version (v1_6).
 * Add steps here when you ship new features; bump the key (e.g. v1_7_territories_new_complete) when you add more.
 */
export const TERRITORIES_NEW_STEPS = (role) => {
  const normalizedRole = normalizeRole(role);
  const steps = [
    {
      id: "upload-leads-chip",
      selector: '[data-tour="upload-leads-chip"]',
      placement: "left",
      copy: {
        Admin: {
          title: "New: Upload Leads from the list",
          content:
            "You can now upload leads for a territory directly from this row. Click the Upload Leads chip to open the upload page for that territory.",
        },
        Manager: {
          title: "New: Upload Leads from the list",
          content:
            "Upload leads for a territory from the list—tap the Upload Leads chip on any row to open the upload page for that territory.",
        },
        "Sales Rep": {
          title: "New: Upload Leads from the list",
          content:
            "Tap the Upload Leads chip on a territory row to open the upload page and add or upload leads for that territory.",
        },
      },
    },
  ];
  return steps.map((step) => {
    const roleCopy = step.copy[normalizedRole] || step.copy["Sales Rep"];
    return {
      selector: step.selector,
      placement: step.placement,
      title: roleCopy.title,
      content: roleCopy.content,
    };
  });
};